import { CREATE_JOB_DETAILS_URL } from '@/utils/constants/constants.js';
import axios from 'axios';

export default {
  methods: {
    extract_entity_type_id(response_data) {
      const entity_data = response_data?.data || {};
      const fallback = Number(entity_data?.entity_type_id || entity_data?.id);
      if (!Number.isNaN(fallback) && fallback > 0) return fallback;
      throw new Error('Entity type id was not returned by create endpoint.');
    },

    async upsert_job_details_with_file(entity_type_id, file) {
      const form_data = new FormData();
      form_data.append('entity_type_id', String(entity_type_id));
      form_data.append('file', file);
      const response = await axios.post(CREATE_JOB_DETAILS_URL, form_data, {
        headers: { ...this.headers, 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
      });
      return response?.data || null;
    },

    async upsert_job_details_without_file(entity_type_id) {
      const response = await axios.post(CREATE_JOB_DETAILS_URL, { entity_type_id }, {
        headers: this.headers,
        withCredentials: true,
      });
      return response?.data || null;
    },

    async upsert_job_details(entity_type_id, details = {}) {
      const has_file = details?.file instanceof File;
      if (has_file) return this.upsert_job_details_with_file(entity_type_id, details.file);
      return this.upsert_job_details_without_file(entity_type_id);
    },

    on_job_file_selected(event) {
      if (!event || !event.target || !event.target.files || !event.target.files.length) {
        this.job_profile_file = null;
        return;
      }
      const selected_file = event.target.files[0] || null;
      this.job_profile_file = selected_file;
      this.has_extraction_preview = false;
      this.create_job_sections = [];
      this.create_job_title = this.trust_type_name || '';
      this.create_job_description = this.trust_type_description || '';
    },

    format_status(status) {
      if (!status) return 'Pending';
      const value = String(status).toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },

    prep_tables() {
      if (!this.trust_types.length) {
        this.table_safe_trust_types = [];
        this.trust_types_headers = [];
        return;
      }
      const source = this.trust_types;
      const mapped = source.map((tt, index) => ({
        __row_id: tt.id,
        No: index + 1,
        'Job Profile': tt.entity_type_name,
        'Date Created': tt.date_created ? new Date(tt.date_created).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '-',
        Status: this.format_status(tt.status),
      }));
      this.table_safe_trust_types = mapped;
      this.trust_types_headers = ['No', 'Job Profile', 'Date Created'];
    },

    handle_trust_types_success(response_data) {
      let all_jobs = response_data.data || [];
      // Strict data isolation — jobs are filtered by sub-program context.
      // Sub-program view: own sub-program jobs + main jobs explicitly assigned to it.
      // Main project view: ONLY main/ungrouped jobs (sub_program_id is null).
      const sp_id = this.active_sub_program_id ? parseInt(this.active_sub_program_id, 10) : null;
      if (sp_id) {
        all_jobs = all_jobs.filter((j) => {
          if (j.sub_program_id === sp_id) return true;
          if (j.sub_program_id) return false;
          const assigned = Array.isArray(j.assigned_sub_program_ids) ? j.assigned_sub_program_ids : [];
          return assigned.includes(sp_id);
        });
      } else {
        all_jobs = all_jobs.filter((j) => !j.sub_program_id);
      }
      this.trust_types = all_jobs;
      this.trust_type_count = this.trust_types.length;
      this.all_children = Array.isArray(this.trust_types) ? this.trust_types.slice() : [];
      this.available_children = this.all_children;
      this.prep_tables();
      this.table_render_key += 1;
    },
  },
};
